import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { CustomOptionOfferResponseRuntype } from '../offer';
import { SupplierSolutionRuntype } from '../sourcingScenario';

export const solutionEndpoints = {
    'POST /solutions/custom-part/bulk': endpoint({
        description: 'Fetches the solutions for a particular assembly',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({
            rfq_id: z.string(),
            assembly_id: z.string(),
        }),
        responseBody: z.object({
            custom_part_offers: z.array(CustomOptionOfferResponseRuntype),
            supplier_solutions: z.array(SupplierSolutionRuntype),
        }),
    }),
};
